import lodash from "lodash";

// TYPES

export const USER_DASHBOARD_UPDATE_LOADING_STATUS = "USER_DASHBOARD_UPDATE_LOADING_STATUS";

// ACTIONS

export const updateLoadingStatus = (payload) => ({
    type: USER_DASHBOARD_UPDATE_LOADING_STATUS,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    isLoading:false
};


const LoaderReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case USER_DASHBOARD_UPDATE_LOADING_STATUS: {
            let temp_state = { ...state };
            temp_state["isLoading"]=action.payload
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default LoaderReducer;
